import React from 'react';
import { CpuIcon } from 'lucide-react';
export function Navbar() {
  return <nav className="fixed top-[37px] left-0 right-0 z-50 bg-white border-b border-gray-200 shadow-sm" data-id="element-162">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-163">
        <div className="flex justify-between items-center h-16" data-id="element-164">
          <div className="flex items-center gap-2" data-id="element-165">
            <div className="w-8 h-8 bg-[#13E200] rounded-full flex items-center justify-center" data-id="element-166">
              <CpuIcon className="w-5 h-5 text-black" data-id="element-167" />
            </div>
            <span className="text-2xl font-black tracking-tighter text-black uppercase" data-id="element-168">
              Effy<span className="text-[#13E200]" data-id="element-169">Mobile</span>
            </span>
          </div>

          <div className="hidden md:flex items-center space-x-8" data-id="element-170">
            <a href="#marketplace" className="cricket-nav-link" data-id="element-171">
              Shop
            </a>
            <a href="#plans" className="cricket-nav-link" data-id="element-172">
              Plans
            </a>
            <a href="#business" className="cricket-nav-link" data-id="element-173">
              Business
            </a>
            <a href="#coverage" className="cricket-nav-link" data-id="element-174">
              Coverage
            </a>
          </div>

          <div className="flex items-center gap-4" data-id="element-175">
            <button className="text-sm font-bold text-black hover:text-[#13E200] transition-colors uppercase tracking-wider" data-id="element-176">
              Sign In
            </button>
            <button className="cricket-btn-primary !py-2 !px-6" data-id="element-177">
              Join Effy
            </button>
          </div>
        </div>
      </div>
    </nav>;
}